import { el } from "./dom.js";

export interface BellOptions {
  count?: number;
  onClick?: () => void;
  label?: string;
}

// Inline bell glyph. Uses currentColor so CSS drives the color.
const BELL_SVG =
  '<svg class="bell-glyph" viewBox="0 0 24 24" width="24" height="24" ' +
  'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
  'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
  '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />' +
  '<path d="M13.73 21a2 2 0 0 1-3.46 0" />' +
  "</svg>";

// Notification bell for the PWA top bar. Framework-free; returns a <button>.
export function notificationBell(opts: BellOptions = {}): HTMLButtonElement {
  const count = opts.count ?? 0;
  const label = opts.label && opts.label.length > 0 ? opts.label : "Notifications";
  const ariaLabel = count > 0 ? `${label} (${count} pending)` : label;

  const attrs: Record<string, string | number | boolean | EventListener> = {
    class: "bell",
    type: "button",
    "aria-label": ariaLabel,
  };
  if (opts.onClick) attrs.onclick = opts.onClick;

  const button = el("button", attrs) as HTMLButtonElement;
  button.innerHTML = BELL_SVG;

  if (count > 0) {
    const text = count > 99 ? "99+" : String(count);
    button.append(el("span", { class: "badge" }, [text]));
  }

  return button;
}

// Back chevron for full-page views (e.g. Notifications) reached from the bell.
const BACK_SVG =
  '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
  'focusable="false"><path d="M15 18l-6-6 6-6"/></svg>';

export function backButton(onClick: () => void): HTMLButtonElement {
  const button = el("button", {
    class: "topbar-back",
    type: "button",
    "aria-label": "Back",
    onclick: onClick,
  }) as HTMLButtonElement;
  button.innerHTML = BACK_SVG;
  return button;
}
